module.exports = __webpack_public_path__ + "static/media/ames-ashare.0af553cf.svg";